const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import ShowallContestGrid from './contestants/ShowallContestGrid.jsx';
import Title from './contestants/Title.jsx';

//Action to save and fetch data
import { fetchFrontSetting, fetchallposts, frontimmute, insertPayment, updateFrontData, stripePayment, couponApply } from '../actions/front_actions';

//Import Designs
import { Container, Grid2, Typography, Backdrop, CircularProgress } from '@mui/material';

class Showallcategories extends Component {

    constructor(props) {
        super(props);
        this.state = { listgrid: "grid", wait: 1 };
    }

    componentDidMount = () => {
        this.setState({ wait: 1 })
        this.props.fetchFrontSetting(this.props.SITE_URL);
        let short_atrr = this.props.shortagrument;
        short_atrr.postperpage = 500;
        this.props.fetchallposts(this.props.SITE_URL, null, short_atrr, 1, '').then(res => {
            this.setState({ wait: 0 });
        });
    }

    render() {
        const { t, i18n } = this.props;
        const shortatts = this.props.shortagrument;
        const values = this.props.model;

        if ((values) && (this.state.wait != 1)) {
            const current_date = new Date(values.current_date);
            return (
                <Container className="wpvc_showcontestant_container">
                    {this.props.shortagrument.title != null &&
                        <Title
                            short={shortatts}
                        />
                    }
                    {
                        values.taxonomy.map((object, i) =>
                            <Container key={i} className="wpvc_showallcategories_container">
                                <Grid2 container className="wpvc_contest_title">
                                    <Typography
                                        variant="h5"
                                        className="wpvc_grid_header"
                                    >
                                        {object.category_name}
                                    </Typography>
                                </Grid2>
                                <ShowallContestGrid {...values}
                                    view={this.state.listgrid}
                                    short={shortatts}
                                    SITE_URL={this.props.SITE_URL}
                                    CONSTANT={this.props.CONSTANT}
                                    term_id={object.term_id}
                                    index={i}
                                />
                            </Container>
                        )
                    }
                </Container>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }
    }
}

const settingstate = state => {
    return { model: state.wpvcfrontdata };
}

export default connect(settingstate, { frontimmute, fetchFrontSetting, fetchallposts, updateFrontData, insertPayment, stripePayment, couponApply })(withTranslation("translations")(Showallcategories));